<template>
  <li
    class="control-menu__unit control-menu__unit--has-child"
    :class="{
      'control-menu__unit--has-child--open': isOpenState,
    }"
    @click="toggleState"
  >
    <a class="control-menu__link" role="button">
      <span :class="iconClass" class="control-menu__icon iconfont"></span>
      <div>
        <span>{{ title }}</span>
        <span
          :class="{
            'control-menu__menu-icon-open': isOpenState,
          }"
          class="control-menu__menu-icon iconfont isub-menu"
        ></span>
      </div>
    </a>
    <transition name="toc-submenu">
      <ul v-show="isOpenState" class="control-menu__sub">
        <slot></slot>
      </ul>
    </transition>
  </li>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const props = withDefaults(
  defineProps<{
    iconClass: string
    title: string
    defaultOpen?: boolean
  }>(),
  {
    defaultOpen: false,
  },
)

const isOpenState = ref(props.defaultOpen)

const toggleState = (): void => {
  isOpenState.value = !isOpenState.value
}
</script>
